/**
 * 기획전 상품리스트(campaign-product-list) 카드 나눠 붙이기.
 *
 * 서버는 탭마다 처음 일부 카드만 화면에 그리고, 나머지는 <template data-lazy-cards> 에 넣어 둔다.
 * 탭 목록 끝의 sentinel 이 화면 아래 가까이 오면 다음 묶음을 꺼내 붙인다.
 * - 탭을 누르면 앞쪽 탭을 먼저 모두 펼쳐, 이동 중 위쪽 높이가 바뀌어 목적지가 밀리지 않게 한다.
 * - 붙인 뒤 회원 등급 가격(employee-discount.js)과 재고 표시(inventory-validation.js)를 다시 적용한다.
 */
(function () {
  'use strict';

  var BATCH_SIZE = 24;
  var ROOT_MARGIN = '0px 0px 800px 0px';

  function reapplyCardScripts() {
    // 회원 등급 가격: employee-discount.js 가 DOMContentLoaded 에 한 번만 적용하므로 다시 적용한다.
    var priceType = null;
    try { priceType = sessionStorage.getItem('discount_type'); } catch (e) { priceType = null; }
    if (priceType && window.FilaPriceDisplay && typeof window.FilaPriceDisplay.update === 'function') {
      window.FilaPriceDisplay.update(priceType);
    }

    // 재고(품절) 표시: 연속으로 붙일 때 한 번만 다시 검사한다.
    if (window.InventoryValidation && typeof window.InventoryValidation.init === 'function') {
      clearTimeout(reapplyCardScripts.timer);
      reapplyCardScripts.timer = setTimeout(function () {
        window.InventoryValidation.init();
      }, 300);
    }
  }

  // template 에서 count 개(0 이면 전부)의 카드를 꺼내 template 바로 앞에 붙인다. 붙인 수를 돌려준다.
  function revealCards(template, count) {
    var content = template.content;
    var cards = [];
    var node = content.firstElementChild;
    while (node && (count === 0 || cards.length < count)) {
      cards.push(node);
      node = node.nextElementSibling;
    }
    if (!cards.length) return 0;

    var fragment = document.createDocumentFragment();
    cards.forEach(function (card) { fragment.appendChild(card); });
    template.parentNode.insertBefore(fragment, template);
    return cards.length;
  }

  function hasMore(template) {
    return !!(template && template.content.firstElementChild);
  }

  function initSection(section, observer) {
    var template = section.querySelector('template[data-lazy-cards]');
    var sentinel = section.querySelector('[data-lazy-cards-sentinel]');
    if (!template || !sentinel) return;
    section.lazyTemplate = template;
    sentinel.lazySection = section;
    observer.observe(sentinel);
  }

  function loadMore(section, observer) {
    var template = section.lazyTemplate;
    if (!hasMore(template)) return;

    var sentinel = section.querySelector('[data-lazy-cards-sentinel]');
    // 화면 위쪽(이미 지나간 곳)에 붙이면 보고 있던 내용이 밀리므로, 늘어난 높이만큼 스크롤을 보정한다.
    var sentinelTop = sentinel ? sentinel.getBoundingClientRect().top : 1;
    var before = section.offsetHeight;

    revealCards(template, BATCH_SIZE);

    if (sentinelTop < 0) {
      window.scrollBy(0, section.offsetHeight - before);
    }
    reapplyCardScripts();

    if (!hasMore(template)) {
      if (sentinel) {
        observer.unobserve(sentinel);
        sentinel.remove();
      }
      return;
    }

    // 붙인 뒤에도 sentinel 이 감지 범위 안이면 관찰 이벤트가 다시 오지 않으므로 직접 이어서 붙인다.
    requestAnimationFrame(function () {
      if (!sentinel || !sentinel.isConnected) return;
      var rect = sentinel.getBoundingClientRect();
      if (rect.top < window.innerHeight + 800 && rect.bottom > -800) loadMore(section, observer);
    });
  }

  function revealAll(section) {
    var template = section.lazyTemplate;
    if (!hasMore(template)) return;
    revealCards(template, 0);
    var sentinel = section.querySelector('[data-lazy-cards-sentinel]');
    if (sentinel) sentinel.remove();
    reapplyCardScripts();
  }

  function initContainer(container) {
    var sections = Array.prototype.slice.call(container.querySelectorAll('[data-tab-products-section]'));
    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.target.lazySection) {
          loadMore(entry.target.lazySection, observer);
        }
      });
    }, { rootMargin: ROOT_MARGIN });

    sections.forEach(function (section) { initSection(section, observer); });

    // 탭 클릭: tab-products.js 가 목적지 위치를 계산하기 전에(캡처 단계) 앞쪽 탭을 모두 펼친다.
    container.addEventListener('click', function (event) {
      var tab = event.target.closest && event.target.closest('[data-tab-products-tab]');
      if (!tab || !container.contains(tab)) return;
      var targetIndex = parseInt(tab.getAttribute('data-tab-index'), 10);
      if (isNaN(targetIndex)) return;
      sections.forEach(function (section) {
        var index = parseInt(section.getAttribute('data-section-index'), 10);
        if (index < targetIndex) revealAll(section);
      });
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-tab-products]').forEach(function (container) {
      if (container.dataset.lazyCardsInit) return;
      container.dataset.lazyCardsInit = '1';
      initContainer(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
